import { config } from "../env";
import { Delete, patch, post, } from "./helpers/http-handler";

// Legal Update
export const legalUpdate = (payload: object) =>
	post(`${config.API_URL}/legal-update/getblogs`,payload);

// Create Legal Update
export const createLegalUpdate = (payload: object) =>
	post(`${config.API_URL}/legal-update`,payload);

export const editLegalUpdate = (id: string, payload: object) =>
	patch(`${config.API_URL}/legal-update/${id}`, payload);

//Get Specific Legal Update
export const getSpecificLegal = (payload: object) =>
	post(`${config.API_URL}/legal-update/getblogs`,payload);

export const deleteSpecificLegal = (id: string) =>
	Delete(`${config.API_URL}/legal-update/delete-blog/${id}`);